import { useCallback, useEffect } from 'react';
import { ESC_KEY_CODE } from 'site-modules/shared/constants/key-codes';

export const useEscPressed = ({ isEnabled, handler }) => {
  const handleKeydown = useCallback(
    event => {
      if (event.keyCode === ESC_KEY_CODE) {
        handler();
      }
    },
    [handler]
  );

  useEffect(() => {
    if (isEnabled) {
      document.addEventListener('keydown', handleKeydown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [isEnabled]);
};
